import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api } from '../../lib/axios.js';
import { useAuthStore } from '../../stores/authStore.js';

function parsearToken(accessToken) {
  const payload = JSON.parse(atob(accessToken.split('.')[1]));
  return { id: payload.id, rol: payload.rol, nombre: payload.nombre };
}

export function useLogin() {
  const setAuth = useAuthStore((s) => s.setAuth);
  const navigate = useNavigate();

  return useMutation({
    mutationFn: (credentials) => api.post('/auth/login', credentials).then((r) => r.data),
    onSuccess: ({ accessToken }) => {
      setAuth(accessToken, parsearToken(accessToken));
      navigate('/dashboard');
    },
  });
}

export function useLogout() {
  const clearAuth = useAuthStore((s) => s.clearAuth);
  const navigate = useNavigate();

  return async () => {
    await api.post('/auth/logout').catch(() => {});
    clearAuth();
    navigate('/login');
  };
}

export async function intentarRefreshSilencioso(setAuth) {
  try {
    const { data } = await api.post('/auth/refresh');
    setAuth(data.accessToken, parsearToken(data.accessToken));
    return true;
  } catch {
    return false;
  }
}
